import { selectVillage } from './selectVillage';
import { IState } from '../../store';

export function selectRegionId(state: IState): number | undefined {
  const village = selectVillage(state);

  return village.regionId;
}
